import ecran from '../../../../../core/injectors/ecran.injector';

export default ecran({
    source: 'mr0138',
    ecrans: ['00-2']
});
